module.exports = __webpack_public_path__ + "static/media/site_files.24bebfd5.png";